var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.407,
    height: 39.408,
    viewBox: "0 0 39.407 39.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1751.689-77.592A9.7,9.7,0,0,1,1742-87.281v-19.03a9.7,9.7,0,0,1,9.688-9.689h19.031a9.7,9.7,0,0,1,9.688,9.689v19.03a9.7,9.7,0,0,1-9.688,9.689Zm-5.509-28.719v19.03a5.516,5.516,0,0,0,5.509,5.51h19.031a5.516,5.516,0,0,0,5.509-5.51v-19.03a5.515,5.515,0,0,0-5.509-5.509h-19.031A5.515,5.515,0,0,0,1746.18-106.311Zm5.133,9.515a9.9,9.9,0,0,1,9.891-9.892A9.9,9.9,0,0,1,1771.1-96.8,9.9,9.9,0,0,1,1761.2-86.9,9.9,9.9,0,0,1,1751.313-96.8Zm4.179,0a5.72,5.72,0,0,0,5.712,5.713,5.718,5.718,0,0,0,5.711-5.713,5.719,5.719,0,0,0-5.711-5.711A5.719,5.719,0,0,0,1755.491-96.8Zm13.582-10.186a2.342,2.342,0,0,1,2.341-2.34,2.342,2.342,0,0,1,2.34,2.34,2.343,2.343,0,0,1-2.34,2.341A2.343,2.343,0,0,1,1769.073-106.983Z",
    transform: "translate(-1742 116)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.4980db33.svg";
export { ForwardRef as ReactComponent };